
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-width":"2","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.121 18.121A2.99 2.99 0 018 19H1v-7c0-.828.336-1.578.879-2.121A2.99 2.99 0 014 9h4a2.99 2.99 0 012.121.879A2.99 2.99 0 0111 12v4a2.99 2.99 0 01-.879 2.121z","opacity":".5"}}),_c('path',{attrs:{"d":"M19 14H9a2.99 2.99 0 01-2.121-.879A2.99 2.99 0 016 11V4c0-.828.336-1.578.879-2.121A2.99 2.99 0 019 1h7a2.99 2.99 0 012.121.879A2.99 2.99 0 0119 4v10z","fill":"#25f"}})])])
          )
        }
      }
    